import apiClient from './client';
import { User, UserRole } from '../types/Auth';
import { API_ENDPOINTS } from './endpoints';

export const getUsers = async (): Promise<User[]> => {
    const response = await apiClient.get(API_ENDPOINTS.USERS);
    let users: any[] = [];

    if (response.data && Array.isArray(response.data.users)) {
        users = response.data.users;
    } 
    else if (Array.isArray(response.data)) {
        users = response.data;
    } else {
        console.warn("Unexpected data structure from getUsers API:", response.data);
    }

    return users.map((user: any) => ({
        ...user,
        roles: user.roles || [],
        // Normalize welcome/accept fields if backend provides them
        welcome_sent: typeof user.welcome_sent === 'boolean' ? user.welcome_sent : !!user.welcome_sent,
        accepted_at: user.accepted_at || user.acceptedAt || user.accepted || undefined,
        // Normalize optional it_role field (backend might use different casing)
        it_role: user.it_role || user.itRole || undefined,
    }));
};

export const createUser = async (data: any): Promise<User> => {
    const response = await apiClient.post(API_ENDPOINTS.USERS, data);
    return response.data;
};

export const updateUserRole = async ({ id, role }: { id: string; role: UserRole }): Promise<User> => {
    const response = await apiClient.put(API_ENDPOINTS.UPDATE_USER_ROLE(id), { role_name: role });
    return response.data;
};

export const deactivateUser = async (id: string): Promise<void> => {
    await apiClient.delete(`${API_ENDPOINTS.USERS}/${id}`);
};

export const updateUser = async ({ id, data }: { id: string; data: any }): Promise<User> => {
    const response = await apiClient.put(`${API_ENDPOINTS.USERS}/${id}`, data);
    return response.data;
};
